import { DatasetTableMode } from "components/dashboard/dataset-table/utils/interfaces";
import { DatasetFullDefaultConfig } from "models/dataset-models";
import { DweenTimeUnitEnum } from "utils/enums";

export const defaultDatasetTableConfig: DatasetFullDefaultConfig = {
  config: {
    alignStartTo: DweenTimeUnitEnum.HOURS,
    startOffsetUnits: DweenTimeUnitEnum.HOURS,
    startOffset: 0,
    lagUnits: DweenTimeUnitEnum.MONTHS,
    lagOffset: 0,
    leadUnits: DweenTimeUnitEnum.HOURS,
    leadOffset: 0,
    stepUnits: DweenTimeUnitEnum.HOURS,
    stepSize: 1,
    startAutoRefreshFrequency: 0,
    dateFormat: DweenTimeUnitEnum.MINUTES,
    transposed: false,
    hideDateColumn: false,
    showEmpty: true,
    showTotal: false,
    totalType: "SUM",
    itemsPerPage: 10,
    sort: "DESC",
  },
  mode: DatasetTableMode.SINGLE,
  datasets: [],
};

export const totalTypeDropdownSelectorOptions = [
  { label: "Sum", value: "SUM" },
  { label: "Average", value: "AVG" },
];
